import { Injectable } from '@angular/core';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class CsvReportService {
  private apiSpringUrl = '/spring/csvreport';

  constructor(private http: HttpService) { }

  postSpring(
    reportCd: string,
    ownerId: number,
    parameter1Tx: string,
    parameter2Tx: string,
    parameter3Tx: string,
    updprogramCd: string
  ): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/${reportCd}`;
    let jsonInput = {
        ownerId: ownerId,
        parameter1Tx: parameter1Tx,
        parameter2Tx: parameter2Tx,
        parameter3Tx: parameter3Tx,
        updprogramCd: updprogramCd,
      };
    return this.http.post(url, jsonInput);
  }

}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/csv-report/csv-report.service.ts